// A project's rental period on its Project details card (owner, 2026-09-15): how long it runs and where today sits
// in it. Dates are calendar dates (YYYY-MM-DD) in the company timezone, first and last day included.

const DAY = 86_400_000;
const days = (from: string, to: string) => Math.round((Date.parse(to) - Date.parse(from)) / DAY);

export type ProjectTimeline =
  | { kind: 'none' }
  /** only one end is known: no length, no progress */
  | { kind: 'open' }
  | { kind: 'upcoming'; total: number; startsIn: number }
  | { kind: 'running'; total: number; day: number; left: number }
  /** past its end date while still active: worth a warning */
  | { kind: 'overrun'; total: number; overBy: number }
  | { kind: 'ended'; total: number };

export function projectTimeline(
  start: string | null,
  end: string | null,
  today: string,
  active: boolean,
): ProjectTimeline {
  if (!start && !end) return { kind: 'none' };
  if (!start || !end) return { kind: 'open' };
  const total = days(start, end) + 1;
  if (today < start) return { kind: 'upcoming', total, startsIn: days(today, start) };
  if (today > end)
    return active ? { kind: 'overrun', total, overBy: days(end, today) } : { kind: 'ended', total };
  const day = days(start, today) + 1;
  return { kind: 'running', total, day, left: total - day };
}
